// Version in the URL, so browsers that cached the old logo (Apache sent it with a 4 hour max-age,
// favicons are kept even longer) load the new one. Bump it when the logo changes again.
export const LOGO_URL = '/logo.svg?v=2'
